import classNames from "classnames";
import React, { FunctionComponent, memo, useMemo } from "react";

import {
  flexAlignClass,
  flexJustifyClass,
  IStyleFlexAlign,
  IStyleFlexJustify,
  IStyleSize,
  sizeClass,
} from "./../Style";

interface Props extends Partial<IStyleFlexJustify & IStyleFlexAlign & IStyleSize> {}

export const FloatedList: FunctionComponent<Props> = memo(({ size, align, justify, children }) => {
  const classes = useMemo(
    () => classNames("floated-list", sizeClass(size), flexJustifyClass(justify), flexAlignClass(align)),
    [size, justify, align],
  );
  return <div className={classes}>{children}</div>;
});

FloatedList.defaultProps = {
  size: "sm",
  justify: "flex-start",
  align: "baseline",
};
